export const ENABLE_DEBUGGING = 'ENABLE_DEBUGGING';
export const DISABLE_DEBUGGING = 'DISABLE_DEBUGGING';
export const TOGGLE_FIREBASE_AUTH = 'TOGGLE_FIREBASE_AUTH';
export const TOGGLE_FIREBASE_DB = 'TOGGLE_FIREBASE_DB';
export const TOGGLE_API_JWT = 'TOGGLE_API_JWT';
export const SET_LOCALE = 'SET_LOCALE';

export const enableDebugging = () => ({
  type: ENABLE_DEBUGGING,
});

export const disableDebugging = () => ({
  type: DISABLE_DEBUGGING,
});

export const toggleFirebaseAuth = () => ({
  type: TOGGLE_FIREBASE_AUTH,
});

export const toggleFirebaseDb = () => ({
  type: TOGGLE_FIREBASE_DB,
});

export const toggleApiJwt = () => ({
  type: TOGGLE_API_JWT,
});

export const setLocale = locale => ({
  type: SET_LOCALE,
  locale,
});



// WEBPACK FOOTER //
// ./src/actions/feature-toggles.js